import { Fragment } from "react";
import { respondTo } from "@utilities/styled-components";
import React, { useState, useContext } from "react";
import styled from "styled-components";
import Banner from "./Banner/Banner";
import BestOffer from "./Promotion/BestOffer";
import ProductOnSale from "./ProductOnSale/ProductOnSale";
import MostPopular from "./Promotion/MostPopular";
import DisclaimerText from "./Header/DisclaimerText";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import AddItemToCart from "@pages/Cart/ShoppingCart/AddItemToCart";

interface Props {}

function HomePage(props: Props) {
  const webSettingsData: any = useContext(WebSettingsContext);
  const {} = props;
  const [showAddToCart, setShowAddToCart] = useState(false);
  return (
    <div style={{ minHeight: "79vh" }}>
      <DisclaimerText />
      <AddItemToCart
        status={showAddToCart}
        onClose={setShowAddToCart}
      ></AddItemToCart>
      <section>
        <div className="promotional-area">
          <Banner />
        </div>
      </section>
      {webSettingsData?.showPromotionalItems ? (
        <div className="row best-offer-wraper">
          <div className="col-lg-12">
            <div className="best-offer-position">
              <BestOffer />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="row">
        <div className="col-lg-12">
          <ProductOnSale onAddToCartActon={setShowAddToCart} />
        </div>
      </div>
      {webSettingsData?.showMostPopularItems ? (
        <div className="row">
          <div className="col-lg-12 most-popu-position">
            <MostPopular />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default HomePage;
